import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App.js';
import { Feilgrense } from './komponenter/Feilgrense.js';
import { ApiFeil } from './api/klient.js';
import { lastMiljo } from './felles/miljo.js';
import './styles.css';

const koe = new QueryClient({
  defaultOptions: {
    queries: {
      // Never retry an authorization failure: the answer will not change, and
      // retrying turns one clear 403 into four, several seconds apart.
      retry: (antallForsok, feil) => {
        if (feil instanceof ApiFeil && feil.status >= 400 && feil.status < 500) return false;
        return antallForsok < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

const rot = document.getElementById('rot');
if (!rot) throw new Error('Fant ikke #rot i index.html');

// Configuration is fetched before anything renders, so no component ever has to
// cope with a half-configured application.
lastMiljo()
  .then(() => {
    createRoot(rot).render(
      <StrictMode>
        {/* Ytterst, utenfor providerne: feiler QueryClientProvider eller
            ruteren selv, finnes det ingen skjerm igjen å tegne feilen i.
            Her er full innlasting det eneste ærlige tilbudet — grensen
            innenfor rutene tar alt som kan repareres uten. */}
        <Feilgrense omfang="appen">
          <QueryClientProvider client={koe}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </QueryClientProvider>
        </Feilgrense>
      </StrictMode>,
    );
  })
  .catch((feil: unknown) => {
    // Nothing can work without configuration; say so plainly rather than
    // presenting an empty page.
    rot.textContent =
      'Enklere styring er feilkonfigurert og kan ikke starte. Kontakt systemansvarlig.';
    // Rethrown on the next tick so the failure reaches the browser's own error
    // reporting — and anything monitoring it — with its stack intact, rather
    // than existing only as a console line.
    setTimeout(() => {
      throw feil;
    });
  });
